import style from "./style.module.scss";

function Item({ video, videoText, text }) {
    return <div className={style.Item}>
        <div className={style.container}>
            <div className={style.videoCnt}>
                <video src={video} muted autoPlay loop />
                <div className={style.videoText}>{
                    videoText.map((txt, i) => {
                        return [txt, (i !== (videoText.length - 1)) ? <br key={i} /> : null];
                    })
                }</div>
            </div>

            <div className={style.textPart + " " + style.text}>
                {text}
            </div>
        </div>
    </div>
}

export default Item;